import React from 'react';
import { Link } from 'react-router-dom';
import { FaBullhorn, FaPeopleCarry, FaIndustry, FaClipboardList } from 'react-icons/fa'; // Updated icons
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';

const Formdashboard = () => {
    return (
        <div className="mt-1" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '200px', width: '100%' }} />

            <div className="container my-4">
                <h2 className="text-center mb-4">Awards Nomination Forms</h2>

                {/* Award Forms Buttons */}
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">

                    <div className="col">
                        <Link to="/form-form3f7" className="btn btn-outline-warning d-flex align-items-center justify-content-center p-4">
                            <FaIndustry className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - Academician Excellence Award
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f8" className="btn btn-outline-info d-flex align-items-center justify-content-center p-4">
                            <FaClipboardList className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - HMA’s Best Student Chapter Award
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f6" className="btn btn-outline-danger d-flex align-items-center justify-content-center p-4">
                            <FaPeopleCarry className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - CSR Award of the Year
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f5" className="btn btn-outline-success d-flex align-items-center justify-content-center p-4">
                            <FaBullhorn className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - HR Manager of the Year
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f2" className="btn btn-outline-warning d-flex align-items-center justify-content-center p-4">
                            <FaPeopleCarry className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - Manager of the Year
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f3" className="btn btn-outline-info d-flex align-items-center justify-content-center p-4">
                            <FaIndustry className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - Women Achiever Award of Excellence
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f4" className="btn btn-outline-secondary d-flex align-items-center justify-content-center p-4">
                            <FaClipboardList className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - IT Professional of the Year
                        </Link>
                    </div>



                    <div className="col">
                        <Link to="/form-form3f9" className="btn btn-outline-secondary d-flex align-items-center justify-content-center p-4">
                            <FaBullhorn className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - Small Scale Entrepreneur of the Year
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f10" className="btn btn-outline-primary d-flex align-items-center justify-content-center p-4">
                            <FaPeopleCarry className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - Young Manager of the Year
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f12" className="btn btn-outline-primary d-flex align-items-center justify-content-center p-4">
                            <FaIndustry className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - ENTREPRENEUR OF THE YEAR
                        </Link>
                    </div>

                    <div className="col">
                        <Link to="/form-form3f1" className="btn btn-outline-danger d-flex align-items-center justify-content-center p-4">
                            <FaBullhorn className="me-3" style={{ fontSize: '30px' }} />
                            Form 3 - Pharma Leader of the Year
                        </Link>
                    </div>

                </div>
            </div>

            <footer className="bg-light py-4 mt-auto">
                <div className="text-center">
                    <p className="m-0" style={{ fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#3498db', textDecoration: 'none', marginLeft: '5px' }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" className="img-fluid" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </div>
    );
};

export default Formdashboard;
